import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="heading,text,buttons,image" theme="light" className="padding-zero-visualizer see-how-it-works how-it-work-font how-it-work-text-align how-it-work-img-align how-it-work-img-Z" mdxType="TextBlock" />
    <h3 {...{
      "id": "see-how-it-works"
    }}>{`See how it works.`}</h3>
    <p>{`Check out the interactive demo that shows a sample
PDF input and the JSON output side-by-side. Click on a section of the PDF
to see the corressponding JSON output. You can extract a variety of elements such as
paragraphs, headers, tables, and figures/images.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://acrobatservices.adobe.com/dc-visualizer-app/index.html"
        }}>{`Interactive demo`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://video.tv.adobe.com/v/333506"
        }}>{`Watch the video`}</a></li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1010px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "106.87500000000001%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/70033a6a664f1165c319d2acb4c1b5fa/5530d/ExtractVisualizer_Graphic.webp 320w", "/document-services/static/70033a6a664f1165c319d2acb4c1b5fa/0c8fb/ExtractVisualizer_Graphic.webp 640w", "/document-services/static/70033a6a664f1165c319d2acb4c1b5fa/e6b23/ExtractVisualizer_Graphic.webp 1010w"],
            "sizes": "(max-width: 1010px) 100vw, 1010px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/70033a6a664f1165c319d2acb4c1b5fa/dd4a7/ExtractVisualizer_Graphic.png 320w", "/document-services/static/70033a6a664f1165c319d2acb4c1b5fa/0f09e/ExtractVisualizer_Graphic.png 640w", "/document-services/static/70033a6a664f1165c319d2acb4c1b5fa/08990/ExtractVisualizer_Graphic.png 1010w"],
            "sizes": "(max-width: 1010px) 100vw, 1010px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/70033a6a664f1165c319d2acb4c1b5fa/08990/ExtractVisualizer_Graphic.png",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <TextBlock slots="heading, text" theme="light" className="how-it-work-richText padding-zero-visualizer rich-text-data how-it-work-font" mdxType="TextBlock" />
    <h3 {...{
      "id": "turn-your-pdf-into-rich-data"
    }}>{`Turn your PDF into rich data.`}</h3>
    <p>{` Extracted content is output in a structured JSON file - with tables optionally included as CSV or XLSX files and images
saved as PNG files-so you can easily store, analyze, and manipulate the data in a variety of downstream systems.`}</p>
    <TextBlock slots="assetImg" theme="light" width="100%" imageOnly className="padding-zero-visualizer media-bottom-padding" mdxType="TextBlock" />
    <p>{`how-it-work-img`}</p>
    <TextBlock slots="text" theme="light" isCentered className="media-bottom-padding link position-up linking How-it-works sec-overview" mdxType="TextBlock" />
    <p>{`We take security seriously - check out our `}<a parentName="p" {...{
        "href": "https://www.adobe.com/content/dam/cc/en/security/pdfs/AdobeDocumentServices_SecurityOverview.pdf"
      }}>{`security overview`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      